import types from './types';

const getDefaultLanguage = axiosConfig => ({
	type: types.GET_DEFAULT_LANGUAGE,
	params: { axiosConfig }
});

export default {
	getDefaultLanguage
};
